import * as S from "src/constants/StringConstants";
import {
  AppAdditionalInsureds,
  AppAgents,
  AppAlerts,
  AppComments,
  AppGMEGSIDetail,
  AppLTCDetail,
  AppMemos,
  AppPremiumDetail,
  AppProductDetail,
  AppRequirements,
} from "./sections";
import { AppDocuments } from "./sections/documents/documents";

export interface TabProps {
  onDirty: (dirty: boolean) => void;
  onValid?: (valid: boolean, errors: any) => void;
  dirty: boolean;
  changeToURL?: string;
  onChangeURL: () => void;
  isReadonly?: boolean;
  validate: (values: any) => any;
}

export interface Tab {
  path: string;
  name: string;
  component: React.FC<TabProps>;
}

export const pages: Tab[] = [
  { path: "agents", name: S.APP_BUILDER_AGENTS, component: AppAgents },
  { path: "product", name: S.APP_BUILDER_PRODUCT_DETAIL, component: AppProductDetail },
  { path: "premium", name: S.APP_BUILDER_PREMIUM_DETAIL, component: AppPremiumDetail },
  { path: "gme-gsi", name: S.APP_BUILDER_GME_GSI, component: AppGMEGSIDetail },
  { path: "ltc", name: S.APP_BUILDER_LTC_DETAIL, component: AppLTCDetail },
  { path: "comments", name: S.APP_BUILDER_COMMENTS, component: AppComments },
  { path: "requirements", name: S.APP_BUILDER_REQUIREMENTS, component: AppRequirements },
  { path: "additional-insureds", name: S.APP_BUILDER_ADDITIONAL_INSUREDS, component: AppAdditionalInsureds },
  { path: "memos", name: S.APP_BUILDER_MEMOS, component: AppMemos },
  { path: "alerts", name: S.APP_BUILDER_ALERTS, component: AppAlerts },
  { path: "documents", name: S.APP_BUILDER_DOCUMENTS, component: AppDocuments },
];
